<template>
  <div class="main">
    <vue-headful title="泵备件包查询" description="泵备件包查询" />
    <div class="header">
      <div class="left"></div>
      <div class="right"></div>
    </div>
    <div class="container">
      <div class="logo">
        <img src="../assets/spxflow-logo-2C.png" alt="SPX logos" />
      </div>
      <p class="desc">请在下方下拉菜单中依次选择"泵类型”、“泵型号”、“备件种类”、“规格”及”材质“后，点击“提交”，即可查询泵备件包信息。</p>
      <div class="selects">
        <select name="type" id="id_type" v-model="type" :class="{ active: type != '' }">
          <option selected value>泵类型</option>
          <option :key="t.type" :value="t.type" v-for="t in types">
            {{ t.type }}
          </option>
        </select>
        <select name="model" id="id_model" v-model="model" :class="{ active: model != '' }">
          <option value selected>泵型号</option>
          <option :key="m.model" :value="m.model" v-for="m in models">
            {{ m.model }}
          </option>
        </select>
        <select name="part_type" id="id_part_type" v-model="part_type" :class="{ active: part_type != '' }">
          <option value selected>备件种类</option>
          <option :key="pt.part_type" :value="pt.part_type" v-for="pt in part_types">
            {{ pt.part_type }}
          </option>
        </select>
        <select name="spec" id="id_spec" v-model="spec" :class="{ active: spec != '' }">
          <option value selected>规格</option>
          <option :key="s.spec" :value="s.spec" v-for="s in specs">
            {{ s.spec }}
          </option>
        </select>
        <select name="material" id="id_material" v-model="material" :class="{ active: material != '' }">
          <option value selected>材质</option>
          <option :key="ma.material" :value="ma.material" v-for="ma in materials">
            {{ ma.material }}
          </option>
        </select>
        <div>
          <button class="submit" @click="search()" :disabled="type == '' || model == '' || part_type == '' || spec == '' || material == ''">提交</button>
        </div>
      </div>
      <div class="results" v-if="result && !(result.parts == '' && result.parts2 == '')">
        <p>所需备件包</p>
        <div class="result">
          <p v-if="result.parts != ''" class="title">备件包1: {{ result.parts }}</p>
          <img :src="`http://qn.kai-dian.com/spx/${result.image}.png?t=${+new Date()}`" alt v-if="result.image != ''" />
          <p v-if="result.parts2 != ''" class="title">备件包2: {{ result.parts2 }}</p>
          <img :src="`http://qn.kai-dian.com/spx/${result.image2}.png?t=${+new Date()}`" alt v-if="result.image2 != ''" />
          <p v-if="result.desc != ''" class="desc">{{ result.desc }}</p>
        </div>
      </div>
      <div v-else>
        <br />
        <br />
      </div>
    </div>
    <div class="footer">
      <img src="@/assets/footer.png" alt="" />
      <!-- <div class="top"></div>
      <div class="content">
        <div class="qr">
          <img src="@/assets/qr.jpeg" alt="" />
        </div>
        <div class="info">
          <h5>长按左侧二维码关注,了解更多</h5>
          <p>斯必克流体中国</p>
          <p>网址：spxflow.com/cn</p>
          <p>电话：86-21-2208 5888</p>
          <p>售后服务电话：4001-528-008</p>
          <p>邮箱：china.contact@spxflow.com</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { pumpSearch, getPumpTypes, getPumpModels, getPumpPartTypes, getPumpSpecs, getPumpMaterials } from "@/api/request";

export default {
  name: "search2",
  data() {
    return {
      types: [],
      models: [],
      sizes: [],
      part_types: [],
      specs: [],
      materials: [],
      type: "",
      model: "",
      size: "",
      part_type: "",
      spec: "",
      material: "",
      tools: [],
      parts: [],
      result: null,
      image: "",
    };
  },
  methods: {
    async search() {
      let loader = this.$loading.show({
        canCancel: true,
      });
      try {
        let data = await pumpSearch({
          type: this.type,
          model: this.model,
          spec: this.spec,
          part_type: this.part_type,
          material: this.material,
        });
        if (data.result == null) {
          this.result = {};
        } else {
          this.result = data.result;
        }
        loader.hide();
      } catch (error) {
        Toast(error);
        loader.hide();
      }
    },
  },
  watch: {
    async type() {
      let loader = this.$loading.show({
        canCancel: true,
      });
      try {
        let data = await getPumpModels({
          type: this.type,
        });
        this.models = data.models;
        loader.hide();
      } catch (error) {
        Toast(error);
        loader.hide();
      }
    },
    async model() {
      let loader = this.$loading.show({
        canCancel: true,
      });
      try {
        let data = await getPumpPartTypes({
          type: this.type,
          model: this.model,
        });
        this.part_types = data.part_types;
        loader.hide();
      } catch (error) {
        Toast(error);
        loader.hide();
      }
    },
    async part_type() {
      let loader = this.$loading.show({
        canCancel: true,
      });
      try {
        let data = await getPumpSpecs({
          type: this.type,
          model: this.model,
          part_type: this.part_type,
        });
        this.specs = data.specs;
        loader.hide();
      } catch (error) {
        Toast(error);
        loader.hide();
      }
    },
    async spec() {
      let loader = this.$loading.show({
        canCancel: true,
      });
      try {
        let data = await getPumpMaterials({
          type: this.type,
          model: this.model,
          part_type: this.part_type,
          spec: this.spec,
        });
        this.materials = data.materials;
        loader.hide();
      } catch (error) {
        Toast(error);
        loader.hide();
      }
    },
  },
  async mounted() {
    let loader = this.$loading.show({
      canCancel: true,
    });
    try {
      let data = await getPumpTypes({
        type: this.type,
      });
      this.types = data.types;
      loader.hide();
    } catch (error) {
      Toast(error);
      loader.hide();
    }

    // fetch("https://itt-ft.effective-wechat.com/api/pump/models", this.getHeaders("GET"))
    //   .then((res) => {
    //     res.json().then((data) => {
    //       this.models = data;
    //     });
    //   })
    //   .catch((err) => {
    //     alert(err);
    //   });
    // fetch("https://itt-ft.effective-wechat.com/api/pump/sizes", this.getHeaders("GET"))
    //   .then((res) => {
    //     res.json().then((data) => {
    //       this.sizes = data;
    //     });
    //   })
    //   .catch((err) => {
    //     alert(err);
    //   });
    // fetch("https://itt-ft.effective-wechat.com/api/pump/materials", this.getHeaders("GET"))
    //   .then((res) => {
    //     res.json().then((data) => {
    //       this.materials = data;
    //     });
    //   })
    //   .catch((err) => {
    //     alert(err);
    //   });
  },
};
</script>

<style lang="scss" scoped>
.container {
  text-align: center;
  min-height: calc(100vh - 238px);
  .logo {
    padding-top: 20px;
    img {
      margin: 20px auto;
      width: 250px;
    }
  }
  .name {
    font-weight: 700;
    font-size: 18px;
    color: rgba(101, 99, 99, 1);
  }
  .desc {
    color: #656464;
    margin: 0px 24px 24px 24px;
    text-align: left;
    line-height: 32px;
  }
  .selects {
    padding: 0 24px;
    select {
      width: 100%;
      height: 46px;
      border: 1px solid #1d4f48;
      opacity: 0.7;
      background: #fff;
      border-radius: 20px 0px 20px 0px;
      margin-bottom: 17px;
      font-size: 17px;
      font-weight: normal;
      color: rgba(126, 124, 124, 1);
      line-height: 21px;
      padding-left: 10px;
    }
  }
}
.submit {
  margin-top: 12px;
  background: #1d4f48;
  color: #fff;
  border-radius: 21px;
  border: none;
  width: 129px;
  height: 43px;
  font-size: 17px;
  line-height: 43px;
  outline: none;
  &:active {
    background-color: #1d4f48;
    box-shadow: 0 1px #666;
    transform: translateY(1px);
  }

  &:active {
    outline: none;
  }
  &:disabled {
    background-color: #d7d7d7;
  }
}
.results {
  background-color: #f3f3f3;
  padding: 18px;
  margin: 30px 24px;
  border-radius: 5px;

  > p {
    color: #1d4f48;
    line-height: 32px;
    margin: 0;
    margin-bottom: 10px;
    font-weight: 600;
  }

  .result {
    text-align: left;
    background-color: #fff;
    padding: 16px;
    margin-bottom: 20px;
    .title {
      margin: 0px;
      margin-bottom: 10px;
    }
    .desc {
      margin: 0;
      font-size: 14px;
      font-weight: 400;
      color: rgba(101, 100, 100, 1);
      line-height: 23px;
    }
    img {
      margin-top: 10px;
      width: 100%;
    }
  }
}
select.active {
  color: #333 !important;
}

.float {
  position: fixed;
  bottom: 20%;
  right: 0;
  img {
    width: 51px;
  }
}
</style>
